import { IColumn } from 'core-components/library/list/types'
import { getTranslatedText, TTranslationFunction } from 'partner360/helpers/getTranslatedText'

import { TRANSLATION_KEYS } from '../../../configs/translations'
import { TGroupedInitiativeRow } from '../models'

import { IListColumn } from './getColumns'
import { getFinGoalTypeTranslationKey } from './getFinGoal'
import { EMPTY_LIST_VALUE } from './listDictionaries'

export const getListExportRows = (
  rows: TGroupedInitiativeRow[],
  t: TTranslationFunction
): TGroupedInitiativeRow[] => {
  const emptyGroupLabel =
    rows.filter((row) => row.isGroupRow).length === 1
      ? TRANSLATION_KEYS.listView.summary
      : TRANSLATION_KEYS.listView.notSpecified
  return rows.map((row) => ({
    ...row,
    Name: row.isGroupRow
      ? row.groupKey === EMPTY_LIST_VALUE
        ? getTranslatedText({
            t,
            key: emptyGroupLabel,
            replaceParams: [{ key: '{count}', value: String(row.groupItemsCount ?? 0) }],
          })
        : t(row.groupKey ?? '')
      : row.Name,
    developmentBreadcrumb: row.strategicPath?.map((key) => t(key)).join(' → ') ?? '',
    BusinessPriorities: row.businessPriorityNames?.map((name) => t(name)).join(', ') ?? '',
    BusinessUnit: row.BusinessUnit ? t(row.BusinessUnit) : '',
    finGoal: row.isGroupRow ? row.groupMeasureValue : row.finGoal,
    finGoalTypeLabel: row.isGroupRow
      ? ''
      : row.finGoalType
        ? t(getFinGoalTypeTranslationKey(row.finGoalType))
        : '',
  }))
}

/** Excel retains separate description/goal-type fields although the screen combines them. */
export const getListExportColumns = (
  columns: IListColumn[],
  t: TTranslationFunction
): IColumn<TGroupedInitiativeRow>[] =>
  columns.flatMap((column) =>
    column.field === 'Name'
      ? [
          column,
          {
            field: 'Description',
            title: getTranslatedText({
              t,
              key: TRANSLATION_KEYS.dashboard.table.columns.description,
            }),
          },
        ]
      : column.field === 'finGoal'
        ? [
            {
              field: 'finGoalTypeLabel',
              title: getTranslatedText({
                t,
                key: TRANSLATION_KEYS.dashboard.table.columns.finGoalType,
              }),
            },
            column,
          ]
        : [column]
  )
